import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import React from 'react';
import './style.scss';

const HeaderBanner = ({ fields = {}, rendering, params }) => {
  const { text: title, heading: subTitle } = fields;

  const shouldRenderTitle = !!title?.value;
  const shouldRenderSubTitle = !!subTitle?.value;

  return (
    <div
      className={clsx('header__banner content', 'add-margins', params?.Styles)}
      style={
        rendering?.params?.backgroundColor ? { background: rendering?.params?.backgroundColor } : {}
      }
    >
      {shouldRenderSubTitle && (
        <div className="header__banner-subTitle">
          <Text field={subTitle} />
        </div>
      )}
      {shouldRenderTitle && (
        <h2>
          <RichText field={title} />
        </h2>
      )}
    </div>
  );
};

export default HeaderBanner;
